<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card :collapse-action="true" :title="`Face Scan Metrics`">
      <vs-progress v-if="isLoading" indeterminate color="primary" />

      <vs-collapse accordion v-if="!isLoading" type="border" class="mb-2">

        <vs-collapse-item
          v-for="metric in workingMetrics"
          :key="metric.metric_id">
          <div slot="header">
            <span>{{metric.metric.name}}</span>
            <span class="text-sm"> ({{metric.value_vlow}}, {{metric.value_low}}, {{metric.value_med}}, {{metric.value_hi}}, {{metric.value_vhi}})</span>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input
                :label-placeholder="'Very Low'"
                v-model="metric.value_vlow"
                v-on:change="updateMetric(metric)"
                class="w-1/2 mb-8"
              />
              <vs-input
                :label-placeholder="'Low'"
                v-model="metric.value_low"
                v-on:change="updateMetric(metric)"
                class="w-1/2 mb-8"
              />
              <vs-input
                :label-placeholder="'Medium'"
                v-model="metric.value_med"
                v-on:change="updateMetric(metric)"
                class="w-1/2 mb-8"
              />
              <vs-input
                :label-placeholder="'High'"
                v-model="metric.value_hi"
                v-on:change="updateMetric(metric)"
                class="w-1/2 mb-8"
              />
              <vs-input
                :label-placeholder="'Very High'"
                v-model="metric.value_vhi"
                v-on:change="updateMetric(metric)"
                class="w-1/2 mb-8"
              />
            </div>
          </div>

<!--          <div class="vx-row mb-4">-->
<!--            <div class="vx-col w-full">-->
<!--              <vs-textarea-->
<!--                :label="`Body (${property.language.name})`"-->
<!--                v-model="property.body"-->
<!--                class="w-full"-->
<!--              />-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="vx-row">-->
<!--            <div class="vx-col md:w-3/4 w-full mb-2">-->
<!--              <div class="vx-row">-->
<!--                <div class="vx-col w-1/2 mb-2">-->
<!--                  <vs-button v-if="isModified" class="mx-1" @click="saveModifiedProperties">Save Changes</vs-button>-->
<!--                </div>-->
<!--                <div class="vx-col w-1/2 mb-2">-->
<!--                  <vs-button v-if="isModified" type="border" color="warning" @click="revert" class="mx-1">Cancel</vs-button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/4 w-full mb-2">-->
<!--              <vs-button class="ml-auto" color="danger" icon="delete_outline" type="gradient" @click="deleteProperty(property)"></vs-button>-->
<!--            </div>-->
<!--          </div>-->

        </vs-collapse-item>

      </vs-collapse>

    </vx-card>



</template>

<script>
  import types from '@/models';
  import api from '@/http/api';

  export default {
    data() {
      return {
        showNewPropertyDialog: false,
        isLoading: false,
        workingMetrics: [new types.FaceScanProductData()],
        fetchedMetrics: [new types.FaceScanProductData()],
        defaultMetrics: [
          new types.FaceScanProductData({ metric_id: 1, product_id: this.product.product_id, metric: { name: "Heart Rate" } }),
          new types.FaceScanProductData({ metric_id: 2, product_id: this.product.product_id, metric: { name: "Heart Rate Variability" } }),
          new types.FaceScanProductData({ metric_id: 3, product_id: this.product.product_id, metric: { name: "Breathing Rate" } }),
          new types.FaceScanProductData({ metric_id: 4, product_id: this.product.product_id, metric: { name: "Stress Index" } }),
          new types.FaceScanProductData({ metric_id: 5, product_id: this.product.product_id, metric: { name: "Parasympathetic Activity" } }),
          new types.FaceScanProductData({ metric_id: 6, product_id: this.product.product_id, metric: { name: "Cardiac Workload" } }),
          new types.FaceScanProductData({ metric_id: 7, product_id: this.product.product_id, metric: { name: "Blood Pressure" } }),
          new types.FaceScanProductData({ metric_id: 8, product_id: this.product.product_id, metric: { name: "BMI class" } }),
        ],
      }
    },
    props: {
      product: {
        type: types.Product(),
        required: true,
        default: () => {
          return new types.Product()
        }
      },
    },
    watch: {
      product: function (newVal, oldVal) {
        if (newVal === oldVal) return;
        // make sure to add product id to the metrics
        this.defaultMetrics = this.defaultMetrics.map((metric) => {
          metric.product_id = this.product.product_id;
          return metric;
        });
        this.fetchFaceScanData();
      }
    },
    computed: {
    },
    methods: {
      async fetchFaceScanData() {
        this.isLoading = true;
        this.fetchedMetrics = await api.fetchProductFaceScanData(this.product);

        // use the fetched metrics for the values we have - else default to zeroes
        this.workingMetrics = this.defaultMetrics.map((metric) => this.fetchedMetrics.find((m) => m.metric_id === metric.metric_id) || metric);

        this.isLoading = false;
      },
      /**
       * @param {FaceScanProductData} faceScanMetricData
       * @returns {Promise<Boolean>} true if successful, false otherwise
       */
      async updateMetric(faceScanMetricData) {
        const result = await api.updateFaceScanProductMetric(faceScanMetricData, this.product);
        if (result) {
          this.showNotification(true, `UPDATED ${faceScanMetricData.metric.name}`);
          return true;
        } else {
          this.showNotification(false, `ERROR updating ${faceScanMetricData.metric.name}`);
          return false;
        }
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
